import { Form, Formik, FormikHelpers } from "formik"
import { useEffect, useRef, useState } from "react"
import { Avatar } from "shared/components/Avatar";
import { UploadAvatar } from "shared/containers/UploadAvatar";
import { StyledLine, WrapperAvatar } from "shared/styles/GlobalStyle";
import { SettingsBtnsRow, WrapperSettingProfile } from "./style";
import { WrapperFormRow } from "shared/components/WrapperFormRow";
import { ProfileFormData } from "../model/profileFormData";
import { Button } from "shared/components/Button";
import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../api/getProfile";
import { Loader } from "shared/components/Loader";
import { useDispatch } from "react-redux";
import { getInitialValues } from "../model/getInitialValues";
import { closeModal, openModal } from "shared/redux/slice/modalSlice";
import { useFileUploadUp } from "shared/hooks/useFileUploadUp";
import { patchProfile } from "../api/patchProfile";
import { showNotification } from "shared/redux/slice/notificationSlice";
import { validateSchemaProfile } from "../model/validateSchema";

export const SettingProfile = () => {

    const dispatch = useDispatch();

    const [disabled, setDisabled] = useState<boolean>(false);
    const [isEditable, setIsEditable] = useState(false);
    const [editButtonText, setEditButtonText] = useState("Редактировать");
    const [photo, setPhoto] = useState<File | null>(null);
    const { handleFileUpload } = useFileUploadUp();
    
    const formikRef = useRef<FormikHelpers<any>>(null);

    const toggleEdit = () => {
        setIsEditable(!isEditable);
        setEditButtonText(isEditable ? "Редактировать" : "Сохранить");
        if (isEditable && formikRef.current) {
            formikRef.current.submitForm();
        }
    };

    const cancelEdit = async () => {
        // refetch();
        setIsEditable(false);
        setEditButtonText("Редактировать");
        formikRef.current?.resetForm();
        dispatch(closeModal());
    }

    const {isLoading, data, refetch} = useQuery({
        queryKey: ["getProfile"],
        queryFn: () => getProfile(),
        refetchOnWindowFocus: false
    });

    const [currentPhoto, setCurrentPhoto] = useState<string | null>(data?.profile_photo?.read_url ?? null);

    const handlePhotoChange = (file: File) => {
        setPhoto(file);
        setCurrentPhoto(URL.createObjectURL(file));
    };

    const onSubmit = async(values: any) => {
        const { uploadedPhotoInfo } = await handleFileUpload(photo, []);

        const updatedValues = {
            ...values,
        };

        if (uploadedPhotoInfo) {
            updatedValues.profile_photo_hash_name = uploadedPhotoInfo.hash_name;
        }

        patchProfile(updatedValues, data?.id).then(() => {
            refetch();
            dispatch(showNotification({message: "Успешно!", type: "success"}));
        })
        .catch(() => {
            setIsEditable(true);
            setEditButtonText("Сохранить");
        });
    }

    useEffect(() => {
        if (!currentPhoto) {
            setCurrentPhoto(data?.profile_photo?.read_url ?? null);
        }
    }, [data?.profile_photo?.read_url, currentPhoto]);


    if(isLoading) {
        return (
            <Loader />
        )
    }

    return (
        <WrapperSettingProfile>
            <SettingsBtnsRow>
            {isEditable ? (
                <>
                    <Button themeType={isEditable ? "primary" : "outline-2"} onClick={toggleEdit} disabled={disabled}>{editButtonText}</Button>
                    <Button 
                        requiredPermission="add"
                        themeType="outline-2" 
                        onClick={() => dispatch(openModal({
                            isOpen: true,
                            content: (
                                <>Вы точно хотите отменить редактирование?</>
                            ),
                            config: {
                                title: "Вы точно хотите отменить?",
                                btns: [
                                    {
                                        onClick: () => cancelEdit(),
                                        title: "Да",
                                        active: true
                                    },
                                    {
                                        onClick: () => dispatch(closeModal()),
                                        title: "Нет",
                                        active: false
                                    }
                                ]
                            }
                        }))}
                    >Отменить</Button>
                </>
            ) : (
                <>
                    <Button themeType={"outline-2"} onClick={toggleEdit}>{editButtonText}</Button>
                </>
            )
        }
            </SettingsBtnsRow>
            <Formik
                key={data?.id}
                innerRef={formikRef as any}
                initialValues={getInitialValues(data)}
                onSubmit={onSubmit}
                // enableReinitialize
                // validateOnMount
                validationSchema={validateSchemaProfile}
            >
                {({isValid}) => {
                    setDisabled(!isValid);
                    return (
                        <Form>
                            <WrapperAvatar>
                                {isEditable ? (
                                    <UploadAvatar 
                                        initialPhoto={currentPhoto}
                                        onPhotoChange={handlePhotoChange}
                                    />
                                ) : (
                                    <Avatar 
                                        photo={data?.profile_photo ? data?.profile_photo?.read_url : ''} 
                                        name={"Настройки профиля"}
                                        jobs={data?.role?.name} 
                                    />
                                )}
                            </WrapperAvatar>
                            <StyledLine margin="20px 0"/>
                            <WrapperFormRow
                                title="Общие данные" 
                                formData={ProfileFormData.map(row => 
                                    row.map(item => ({ 
                                        ...item, 
                                        disabled: !isEditable,
                                        placeholder: isEditable ? item.placeholder : "",
                                        hidden: item.name === "password" && !isEditable ? true : false,
                                    })
                                ))} 
                            />
                        </Form>
                    )
                }}
            </Formik>
        </WrapperSettingProfile>
    )
}